export function isBrowserDefaulLight() {
  return window.matchMedia('(prefers-color-scheme: light)').matches;
}

export function getDefaultTheme() {
  const localStorageTheme = localStorage.getItem('currentTheme');
  // const browserDefault = isBrowserDefaulLight() ? 'light' : 'dark';
  return localStorageTheme || 'dark';
}
